/** Always-visible help copy for safelisting overrides (create) and correct accountability. */

export const SAFELISTING_OVERRIDE_RECIPE_HEADLINE =
  "Only Override count toward total changes how much they have used. The other two switches are notes on the record.";

export const SAFELISTING_OVERRIDE_RECIPE_STEPS = [
  "Within limits — leave all overrides off.",
  "Over limit, still charge them — turn on Override limit and add Override reason.",
  "Over limit, do not charge them — turn on Override count toward total and add Override reason.",
  "Within limits, do not charge them — turn on Override count toward total only.",
] as const;

export const SAFELISTING_OVERRIDE_FIELD_HINTS = {
  override_count_toward_total:
    "Off = uses their allowance. On = free pass (does not count toward used or remaining).",
  override_days_in_a_row:
    "Approve over the max consecutive-days rule. Record only — still counts unless Override count toward total is on.",
  override_limit:
    "Approve over the total-days quota. Record only — still counts unless Override count toward total is on.",
  override_reason:
    "Required when total quota or consecutive-days rules fail at save. Not the same as correction Reason on old permits.",
} as const;

export const SAFELISTING_CORRECT_HELP_HEADLINE =
  "Past days only. Use edit for today and upcoming coverage. Whole cancel cannot fix expired days.";

export const SAFELISTING_CORRECT_HELP_LINES = [
  "Cancel — removes a past day from quota (day stays on the permit as Cancelled).",
  "Restore — brings a cancelled past day back to Active (may fail if dates conflict).",
  "Don't count toward quota — same as Override count toward total on create (free pass for the whole permit).",
] as const;

export const SAFELISTING_CORRECT_REASON_HINT =
  "Required for every correction (10–1000 characters). Audit only — not Override reason from create.";

export const SAFELISTING_CORRECT_PAST_DAYS_HINT =
  "Check Cancel or Restore on past days below. Today and future days cannot be changed here.";

export const SAFELISTING_CORRECT_DONT_COUNT_HINT =
  "Off = uses their allowance. On = free pass (does not count toward used or remaining).";

/** Read-only lines in list/detail override popover. */
export const SAFELISTING_OVERRIDE_READ_LINES = {
  limitDays: (days: number) =>
    `Override limit — approved over total-days quota (+${days} day${days === 1 ? "" : "s"}). Record only.`,
  daysInARow: "Override Property Manager — approved over consecutive-days rule. Record only.",
  excludedFromQuota: "Override count toward total — free pass (does not count toward allowance).",
} as const;
